(function () {
  "use strict";

  var init = function (root) {
    var toggle = root.querySelector("[data-gift-toggle]");
    var fields = root.querySelector("[data-gift-fields]");
    var offset = root.querySelector("[data-gift-offset]");
    var message = root.querySelector("[data-gift-message]");
    var counter = root.querySelector("[data-gift-counter]");
    var sendOn = root.querySelector("[data-gift-send-on]");
    var errors = root.querySelector("[data-gift-errors]");
    var designInput = root.querySelector("[data-gift-design-input]");
    var previewImage = root.querySelector("[data-gift-preview-image]");
    var previewAmount = root.querySelector("[data-gift-preview-amount]");

    if (toggle && fields) {
      toggle.addEventListener("change", function () {
        var on = toggle.checked;
        fields.disabled = !on;
        fields.hidden = !on;
        if (!on && errors) {
          errors.hidden = true;
          errors.textContent = "";
        }
      });
    }

    if (offset) offset.value = String(new Date().getTimezoneOffset());

    if (message && counter) {
      var max = parseInt(message.getAttribute("maxlength"), 10) || 200;
      var update = function () {
        counter.textContent = max - message.value.length + " characters left";
      };
      message.addEventListener("input", update);
      update();
    }

    if (sendOn) {
      var iso = function (d) {
        return new Date(d.getTime() - d.getTimezoneOffset() * 6e4).toISOString().slice(0, 10);
      };
      var today = new Date();
      var maxDate = new Date(today.getTime() + 90 * 864e5);
      sendOn.min = iso(today);
      sendOn.max = iso(maxDate);
    }

    var designs = Array.prototype.slice.call(root.querySelectorAll("[data-gift-design]"));
    var selectDesign = function (btn) {
      designs.forEach(function (other) {
        var on = other === btn;
        other.classList.toggle("is-selected", on);
        other.setAttribute("aria-checked", on ? "true" : "false");
        other.tabIndex = on ? 0 : -1;
      });
      if (designInput) designInput.value = btn.getAttribute("data-design-name") || "";
      if (previewImage) previewImage.src = btn.getAttribute("data-design-image") || previewImage.src;
    };
    designs.forEach(function (btn, i) {
      btn.tabIndex = btn.getAttribute("aria-checked") === "true" ? 0 : -1;
      btn.addEventListener("click", function () {
        selectDesign(btn);
      });
      btn.addEventListener("keydown", function (e) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        var next = designs[(i + step + designs.length) % designs.length];
        selectDesign(next);
        next.focus();
      });
    });

    if (previewAmount) {
      var productRoot = root.closest(".main-product--root");
      var productId = productRoot && productRoot.getAttribute("data-product-id");
      if (productId) {
        window.addEventListener("theme:product:" + productId + ":variantChanged", function (event) {
          var variant = event.detail && event.detail.variant;
          if (!variant || typeof variant.price === "undefined") return;
          previewAmount.textContent = window.TroopTheme.Utils.formatMoney(variant.price);
        });
      }
    }

    if (errors) {
      var form = root.closest("form");
      if (form) {
        form.addEventListener(
          "submit",
          function () {
            auGiftPendingRoot = toggle && toggle.checked ? root : null;
          },
          true
        );
      }
    }
  };

  var auGiftPendingRoot = null;
  var auGiftErrorBox = null;

  document.addEventListener("au:cart:add-settled", function (event) {
    if (!auGiftPendingRoot) return;
    var box = auGiftPendingRoot.querySelector("[data-gift-errors]");
    auGiftPendingRoot = null;
    if (!box) return;
    if (event && event.detail && event.detail.ok) {
      auGiftErrorBox = null;
      box.hidden = true;
      box.textContent = "";
      return;
    }
    auGiftErrorBox = box;
  });

  document.addEventListener("au:cart:add-error", function (event) {
    var box = auGiftErrorBox;
    auGiftErrorBox = null;
    if (!box) return;
    var text = event && event.detail && event.detail.description;
    if (!text) return;
    box.textContent = text;
    box.hidden = false;
    box.scrollIntoView({ block: "nearest", behavior: "smooth" });
  });

  var boot = function (scope) {
    scope.querySelectorAll("[data-au-gift-builder]").forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
})();
